export default __webpack_public_path__ + "static/media/profile.d84c9ab8.jpeg";